import { useMemo } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import "./_fonts.scss";
import "./_global.scss";

import PublicRoute from "./Components/Routes/PublicRoute.js";
import { WEB_ROUTES } from "./constants.js";
import { baseRoute } from "./Helper";

import { uniqueId } from "lodash";
import ProtectedLayout from "./Components/Layouts/ProtectedLayout.js";
import ProtectedRoute from "./Components/Routes/ProtectedRoute.js";
import Account from "./Pages/Account";
import AgreementHubManagementScreen from "./Pages/AgreementHub/AgreementHubManagementScreen.js";
import ContentManagementScreen from "./Pages/ContentManagement/ContentManagementScreen.js";
import CustomerSupportScreen from "./Pages/CustomerSupport/CustomerSupportScreen.js";
import SingleChatScreen from "./Pages/CustomerSupport/SingleChatScreen.js";
import Dashboard from "./Pages/Dashboard";
import FinanceManagementScreen from "./Pages/FinanceManagement/FinanceManagementScreen.js";
import SalesManagementScreen from "./Pages/SalesManagement/SalesManagementScreen.js";
import SendNotificationScreen from "./Pages/SendNotification/SendNotificationScreen.js";
import Setting from "./Pages/Setting";
import UserManagementScreen from "./Pages/UserManagement/UserManagementScreen.js";
function App() {
  // todo: menu
  const ROUTES = useMemo(() => {
    return [
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.ACCOUNT)}
        element={
          <PublicRoute>
            <Account />
          </PublicRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.DASHBOARD}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Dashboard />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.FINANCIAL_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <FinanceManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SALES_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <SalesManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.USER_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <UserManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.CUSTOMER_SERVICE}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <CustomerSupportScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SINGLE_CHAT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <SingleChatScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.AGREEMENT_HUB}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <AgreementHubManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,

      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.SUPPORT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <Messages />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.PAGE_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <ContentManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,

      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SEND_NOTIFICATION}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <SendNotificationScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SETTING}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Setting />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
    ];
  }, []);

  return (
    <Router>
      <Routes>
        {ROUTES.map((item) => item)}
        <Route
          path={baseRoute("*")}
          element={<Navigate to={WEB_ROUTES.ACCOUNT} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
